module.exports = "<xml>\n  <block type=\"when_run\" x=\"20\" y=\"20\">\n    <next>\n      <block type=\"jump\"></block>\n    </next>\n  </block>\n</xml>\n"


/*****************
 ** WEBPACK FOOTER
 ** ./~/raw-loader!./src/blockly/initblocks.xml
 ** module id = 779
 ** module chunks = 0
 **/